import { InputHTMLAttributes, PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';
import { VariantProps } from 'tailwind-variants';
import { IsVisible } from '../../../../utils';
import { FieldBase, IFieldBaseProps } from '../../Base';
import { radioStyles } from '../styles';
import { IRadioFieldIconProps, RadioFieldIcon } from '../utils/Icon';

export interface IRadioFieldProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'value'>,
    VariantProps<typeof radioStyles.input> {
  containerProps?: {
    className?: string;
    rest?: Omit<IFieldBaseProps, 'className'>;
  };
  iconProps?: IRadioFieldIconProps;
  label?: string;
  labelProps?: {
    className?: string;
  };
  name: string;
  value: string | number | readonly string[];
}

export function RadioField({
  children,
  className,
  containerProps,
  design,
  disabled = false,
  iconProps,
  inputSize = 'md',
  label,
  labelProps,
  name,
  onChange,
  readOnly = false,
  value,
  ...rest
}: PropsWithChildren<IRadioFieldProps>): JSX.Element {
  return (
    <FieldBase
      className={twMerge('', containerProps?.className)}
      {...containerProps?.rest}
    >
      <label
        className={radioStyles.label({
          className: labelProps?.className,
          design,
          disabled: disabled || readOnly,
          errored: !!containerProps?.rest?.error,
          size: inputSize,
        })}
        htmlFor={`${name}-${value}`}
      >
        {children}
        <IsVisible when={!!label}>{label}</IsVisible>

        <input
          className={radioStyles.input({
            className,
            design,
            disabled: disabled || readOnly,
            errored: !!containerProps?.rest?.error,
            inputSize,
          })}
          disabled={disabled}
          id={`${name}-${value}`}
          name={name}
          onChange={onChange}
          readOnly={readOnly}
          type="radio"
          value={value}
          {...rest}
        />

        <RadioFieldIcon
          className={iconProps?.className}
          design={design}
          disabled={disabled || readOnly}
          rest={iconProps?.rest}
          size={inputSize}
        />
      </label>
    </FieldBase>
  );
}
